import styled from 'styled-components';
import SearchInputComponent from '@/components/SearchInput';
import UserInitials from '@/trio-ui/UserInitials';

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 32px;
  margin-bottom: 16px;
`;

const HeaderTitle = styled.p`
  color: ${({ theme }) => theme.colors['neutral-100']};
  font-size: 18px;
  font-weight: 600;
  line-height: 120%;
  flex-grow: 1;
`;

const TableContainer = styled.div`
  & > div {
    overflow: hidden;
    border: 1px solid ${({ theme }) => theme.colors['neutral-40']};
  }

  & table {
    width: 100%;
    border: 0 none;

    & th:first-child,
    & td:first-child {
      border-left: 0 none;
    }

    & th:last-child,
    & td:last-child {
      border-right: 0 none;
    }

    & th {
      border-top: 0 none;
    }

    & tr:last-child td {
      border-bottom: 0 none;
    }
  }
`;

const StyledUserInitials = styled(UserInitials)`
  font-size: 14px;
  margin-right: 12px;
`;

const UserNameAndRole = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 2px;
  min-height: 42.2px;
`;

const UserName = styled.span`
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  color: ${({ theme }) => theme.colors['neutral-100']};
  display: block;
`;

const UserRole = styled.span`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  color: ${({ theme }) => theme.colors['neutral-100']};
  display: block;
`;

const Search = styled(SearchInputComponent)`
  min-width: 260px;
`;

const AddNew = styled.button`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  font-size: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.theme.colors['tertiary-60']};

  svg {
    fill: #fff;
  }
`;

export {
  Header,
  HeaderTitle,
  TableContainer,
  StyledUserInitials,
  UserNameAndRole,
  UserName,
  UserRole,
  Search,
  AddNew,
};
